// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2BKSV","title":"Images45_title__1dkr0","images":"Images45_images__1j3HT"};